module.exports = __webpack_public_path__ + "static/media/baby-emoji-svgrepo-com (1).468fe04c.svg";